import type { AuthUser } from "@/store/auth";

/* Own contract views after a contract switch. The backend decides from the
   paperwork (apps.accounts.contract_timeline.own_contract_views); the
   contract_type fallback covers sessions persisted before the field existed.
   Shared by the sidebar and the route guards so both stay in step. */

export function showsMyTimesheets(user: AuthUser | null | undefined): boolean {
  if (!user || user.role === "contractor") return false;
  return user.contract_views?.timesheets ?? user.contract_type !== "b2b";
}

export function showsMyB2BInvoices(user: AuthUser | null | undefined): boolean {
  if (!user || user.role === "contractor") return false;
  return user.contract_views?.b2b_invoices ?? user.contract_type === "b2b";
}
